import { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import { Button, Col, Row } from "reactstrap";
import { Divider } from "@material-ui/core";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { useAuth } from "hooks/selectors/useAuth";
import { useEventCheckout } from "reducers/eventRegisterSlice";

import generalApi from "@/services/general-api";

import { convert24hTo12h } from "utilities/common";

import applePay from "@/assets/img/endorse/apple-pay.png";
import ccLogo from "@/assets/img/endorse/cc-logo.png";
import googlePay from "@/assets/img/endorse/google-pay.png";
import { ReactComponent as LearnerSvg } from "@/assets/img/endorse/icon_learner.svg";
import { ReactComponent as TncSvg } from "@/assets/img/endorse/icon_T&C.svg";
import paynowLogo from "@/assets/img/endorse/paynow-logo.png";
import { ReactComponent as TimeSvg } from "@/assets/img/Events/icon_clock.svg";
import { ReactComponent as EventSvg } from "@/assets/img/Events/icon_event.svg";
import { ReactComponent as LocationSvg } from "@/assets/img/Events/icon_locate.svg";
import { ReactComponent as TicketSvg } from "@/assets/img/Events/icon_tics.svg";

import styles from "./EventCheckoutSummaryPage.module.scss";

export const EventCheckoutSummaryPage = () => {
	const { checkoutInfo } = useEventCheckout();
	const [accordionOpen, setAccordionOpen] = useState(false);
	const { userData } = useAuth();
	const MySwal = withReactContent(Swal);
	const [paymentmethod, setPaymentmethod] = useState("paynow");
	const { event } = checkoutInfo;
	let navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [loading, setLoading] = useState(false);
	const [disabled, setDisabled] = useState(false);

	console.log("checkoutInfo", checkoutInfo, userData);

	const personal_details = [
		{
			label: "Name",
			value: userData.user.learnermaster_name,
		},
		{
			label: "NRIC",
			value: userData.user.learnermaster_nricmask,
		},
		{
			label: "Date of Birth",
			value: userData.user.learnermaster_dob,
		},
		{
			label: "Nationality",
			value: userData.user.learnermaster_nationality,
		},
		{
			label: "Email",
			value: userData.user.learnermaster_email,
		},
		{
			label: "Mobile",
			value: userData.user.learnermaster_mobile,
		},
		{
			label: "Gender",
			value: userData.user.learnermaster_gender,
		},
	];

	const event_details = [
		{
			label: "Location",
			value: event.event_location,
			icon: LocationSvg,
		},
		{
			label: "Event Date",
			value:
				event.event_from === event.event_to
					? `${moment(event.event_from).format("DD MMM YYYY")}`
					: `${moment(event.event_from).format("DD MMM YYYY")} - ${moment(event.event_to).format(
							"DD MMM YYYY",
					  )}`,
			icon: TimeSvg,
		},
		{
			label: "Event Time",
			value: event.event_time_from
				? `${convert24hTo12h(event.event_time_from)} - ${convert24hTo12h(event.event_time_to)}`
				: "-",
			icon: TimeSvg,
		},
		{
			label: "No of Tickets/Registration",
			value: checkoutInfo.eventregform_quantity,
			icon: TicketSvg,
		},
	];

	const toggleAccordion = () => {
		setAccordionOpen(!accordionOpen);
	};

	const checkboxTNC = useRef(null);
	const canvasRef = useRef(null);

	function selectPaymentmethod(event) {
		const selectedMethod = event.currentTarget.dataset.method;
		setPaymentmethod(selectedMethod);
		console.log(window.OmiseCard);
	}

	/** Apple Pay */

	var applepay_paymentToken;
	var applepay_paymentNetwork;
	async function onApplePayButtonClicked(totalToPay, req_data) {
		// Consider falling back to Apple Pay JS if Payment Request is not available.
		if (!PaymentRequest) {
			return;
		}

		try {
			// Define PaymentMethodData
			const paymentMethodData = [
				{
					supportedMethods: "https://apple.com/apple-pay",
					data: {
						version: 3,
						merchantIdentifier: "merchant.omise.sg.prod",
						merchantCapabilities: ["supports3DS"],
						supportedNetworks: ["amex", "discover", "masterCard", "visa"],
						countryCode: "SG",
					},
				},
			];
			// Define PaymentDetails
			const paymentDetails = {
				total: {
					label:
						"Event Registration " +
						(window.location.href.includes("learn.sda.edu.sg") ? "" : " (Card is not charged)"),
					amount: {
						// "value": "0.01",
						value: totalToPay,
						currency: "SGD",
						country: "SG",
					},
				},
			};
			// Define PaymentOptions
			const paymentOptions = {
				requestPayerName: false,
				requestBillingAddress: false,
				requestPayerEmail: false,
				requestPayerPhone: false,
				requestShipping: false,
				shippingType: "shipping",
			};

			// Create PaymentRequest
			const request = new PaymentRequest(paymentMethodData, paymentDetails, paymentOptions);

			request.onmerchantvalidation = (event) => {
				// Call your own server to request a new merchant session.
				// const merchantSessionPromise = validateMerchant();
				const merchantSessionPromise = fetch(
					(window.location.href.includes("learn.sda.edu.sg")
						? "https://tms.fcacademy.com.sg"
						: "https://staging-tms.fcacademy.com.sg") +
						"/api/authorizeMerchant?event_reg_id=" +
						req_data.eventregform_id +
						"&domain=" +
						(window.location.href.includes("learn.sda.edu.sg")
							? "learn.sda.edu.sg"
							: "falcomm-tms.fcacademy.com.sg"),
				)
					.then((res) => res.json()) // Parse the response as JSON.
					.catch((err) => {
						console.error("Error fetching merchant session", err);
					});

				event.complete(merchantSessionPromise);
				console.log("merchantSessionPromise:", merchantSessionPromise);
			};

			request.onpaymentmethodchange = (event) => {
				if (event.methodDetails.type !== undefined) {
					// Define PaymentDetailsUpdate based on the selected payment method.
					// No updates or errors needed, pass an object with the same total.
					const paymentDetailsUpdate = {
						total: paymentDetails.total,
					};
					event.updateWith(paymentDetailsUpdate);
				}
				// else if (event.methodDetails.couponCode !== undefined) {
				// 	// Define PaymentDetailsUpdate based on the coupon code.
				// 	const total = calculateTotal(event.methodDetails.couponCode);
				// 	const displayItems = calculateDisplayItem(event.methodDetails.couponCode);
				// 	const shippingOptions = calculateShippingOptions(event.methodDetails.couponCode);
				// 	const error = calculateError(event.methodDetails.couponCode);

				// 	event.updateWith({
				// 		total: total,
				// 		displayItems: displayItems,
				// 		shippingOptions: shippingOptions,
				// 		modifiers: [
				// 			{
				// 				data: {
				// 					additionalShippingMethods: shippingOptions,
				// 				},
				// 			},
				// 		],
				// 		error: error,
				// 	});
				// }
			};

			request.onshippingoptionchange = (event) => {
				// Define PaymentDetailsUpdate based on the selected shipping option.
				// No updates or errors needed, pass an object with the same total.
				const paymentDetailsUpdate = {
					total: paymentDetails.total,
				};
				event.updateWith(paymentDetailsUpdate);
			};

			request.onshippingaddresschange = (event) => {
				// Define PaymentDetailsUpdate based on a shipping address change.
				const paymentDetailsUpdate = {};
				event.updateWith(paymentDetailsUpdate);
			};

			console.log("request:");
			console.log(request);

			const response = await request.show();
			console.log("response:");
			console.log(response);
			console.log(response.details.token.paymentData);
			applepay_paymentToken = response.details.token.paymentData;
			applepay_paymentNetwork = response.details.token.paymentMethod.network;
			if (applepay_paymentToken && applepay_paymentNetwork) {
				req_data.applepay_paymentNetwork = applepay_paymentNetwork;
				callApplePayEPayment(applepay_paymentToken, req_data);
			}

			const responseData = await postData(
				(window.location.href.includes("learn.sda.edu.sg")
					? "https://tms.fcacademy.com.sg"
					: "https://staging-tms.fcacademy.com.sg") + "/api/logApplePayResponseData",
				{
					request_data: JSON.stringify(request),
					response: JSON.stringify(response),
					event_reg_id: req_data.eventregform_id,
				},
			);

			const status = "success";
			await response.complete(status);
		} catch (e) {
			// Handle errors
		}
	}

	async function postData(url = "", data = {}) {
		const response = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		});
		return response.json();
	}

	function callApplePayEPayment(applePayPaymentToken, req_data) {
		const omisePublicKeyUAT = process.env.REACT_APP_OMISE_PKEY_UAT;
		const omisePublicKeyPROD = process.env.REACT_APP_OMISE_PKEY_PROD;

		const currentUrl = window.location.href;

		const epaymentPayload = {
			omiseToken: "",
			omiseSource: "",
			eventregform_id: req_data.eventregform_id,
			payment_amount: req_data.eventregform_total_price,
			payment_method: "applepay",
			signature: req_data.dataUrl,
		};

		setLoading(true);
		generalApi
			.epaymentForEvent(epaymentPayload)
			.then((d) => {
				if (d.status == 1) {
					if (currentUrl.includes("learn.sda.edu.sg")) {
						// production to load production pkey
						window.Omise.setPublicKey(omisePublicKeyPROD);
					} else {
						// uat / development to load uat pkey
						window.Omise.setPublicKey(omisePublicKeyUAT);
					}

					const tokenParameters = {
						method: "applepay",
						data: JSON.stringify(applePayPaymentToken),
						merchant_id: "merchant.omise.sg.prod",
						brand: req_data.applepay_paymentNetwork,
					};

					window.Omise.createToken(
						"tokenization",
						tokenParameters,
						function (statusCode, response) {
							console.log(response);

							if (response.object == "error") {
								setLoading(false);
								MySwal.fire({
									title: "",
									html:
										"Error: " +
										response.code
											.toLowerCase()
											.replace("_", " ")
											.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()) +
										" - " +
										response.message
											.toLowerCase()
											.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()),
									icon: "error",
								});
								return;
							}

							const chargePayload = {
								payment_id: d.data.payment_id,
								payment_mode: d.data.payment_mode,
								payment_amount: d.data.payment_amount,
								omiseToken: response.id,
							};

							generalApi
								.epaymentChargeCreditCardForEvent(chargePayload)
								.then((d) => {
									if (d.status == 2) {
										window.location.href = d.url;
										// const newSearchParam = [];
										// for(let entry of searchParams.entries()) {
										// 	newSearchParam.push(entry);
										// }
										// if (d.url.includes("?")) {
										// 	window.location.href = d.url + "&" + createSearchParams(getUrlParams(newSearchParam, checkoutAnalyticsData, courserun_id)).toString();
										// } else {
										// 	window.location.href = d.url + "?" +
										// }
									}
								})
								.catch((error) => {
									console.warn("error", error);
									// console.log(error);
									setLoading(false);
								});
						},
					);
				} else {
					setLoading(false);
				}
			})
			.catch((error) => {
				console.warn("error", error);
				// console.log(error);
				setLoading(false);
			});
	}

	/** Google Pay */

	var googlePayPaymentToken;

	/**
	 * Define the version of the Google Pay API referenced when creating your
	 * configuration
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|apiVersion in PaymentDataRequest}
	 */
	const baseRequest = {
		apiVersion: 2,
		apiVersionMinor: 0,
	};

	/**
	 * Card networks supported by your site and your gateway
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
	 * @todo confirm card networks supported by your site and gateway
	 */
	const allowedCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"];

	/**
	 * Card authentication methods supported by your site and your gateway
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
	 * @todo confirm your processor supports Android device tokens for your
	 * supported card networks
	 */
	const allowedCardAuthMethods = ["PAN_ONLY"];

	/**
	 * Identify your gateway and your site's gateway merchant identifier
	 *
	 * The Google Pay API response will return an encrypted payment method capable
	 * of being charged by a supported gateway after payer authorization
	 *
	 * @todo check with your gateway on the parameters to pass
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#gateway|PaymentMethodTokenizationSpecification}
	 */

	var omise_publicKey;
	if (window.location.href.includes("learn.sda.edu.sg")) {
		omise_publicKey = process.env.REACT_APP_OMISE_PKEY_PROD;
	} else {
		omise_publicKey = process.env.REACT_APP_OMISE_PKEY_UAT;
	}

	const tokenizationSpecification = {
		type: "PAYMENT_GATEWAY",
		parameters: {
			gateway: "omise",
			gatewayMerchantId: omise_publicKey,
		},
	};

	/**
	 * Describe your site's support for the CARD payment method and its required
	 * fields
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
	 */
	const baseCardPaymentMethod = {
		type: "CARD",
		parameters: {
			allowedAuthMethods: allowedCardAuthMethods,
			allowedCardNetworks: allowedCardNetworks,
		},
	};

	/**
	 * Describe your site's support for the CARD payment method including optional
	 * fields
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
	 */
	const cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
		tokenizationSpecification: tokenizationSpecification,
	});

	/**
	 * An initialized google.payments.api.PaymentsClient object or null if not yet set
	 *
	 * @see {@link getGooglePaymentsClient}
	 */
	let paymentsClient = null;

	/**
	 * Configure your site's support for payment methods supported by the Google Pay
	 * API.
	 *
	 * Each member of allowedPaymentMethods should contain only the required fields,
	 * allowing reuse of this base request when determining a viewer's ability
	 * to pay and later requesting a supported payment method
	 *
	 * @returns {object} Google Pay API version, payment methods supported by the site
	 */
	function getGoogleIsReadyToPayRequest() {
		return Object.assign({}, baseRequest, {
			allowedPaymentMethods: [baseCardPaymentMethod],
		});
	}

	/**
	 * Configure support for the Google Pay API
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|PaymentDataRequest}
	 * @returns {object} PaymentDataRequest fields
	 */
	function getGooglePaymentDataRequest(totalToPay) {
		const paymentDataRequest = Object.assign({}, baseRequest);
		paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
		paymentDataRequest.transactionInfo = getGoogleTransactionInfo(totalToPay);
		paymentDataRequest.merchantInfo = {
			// @todo a merchant ID is available for a production environment after approval by Google
			// See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist}
			// merchantId: '01234567890123456789',
			// merchantId: "BCR2DN7T5CW6JQ2T",
			merchantName: "FirstCom Academy Pte Ltd",
		};
		if (window.location.href.includes("learn.sda.edu.sg")) {
			paymentDataRequest.merchantInfo.merchantId = "BCR2DN7T5CW6JQ2T";
		}
		return paymentDataRequest;
	}

	/**
	 * Return an active PaymentsClient or initialize
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/client#PaymentsClient|PaymentsClient constructor}
	 * @returns {google.payments.api.PaymentsClient} Google Pay API client
	 */
	function getGooglePaymentsClient() {
		if (paymentsClient === null) {
			let env_txt = "TEST";
			const currentUrl = window.location.href;

			if (currentUrl.includes("learn.sda.edu.sg")) {
				env_txt = "PRODUCTION";
			}
			paymentsClient = new window.google.payments.api.PaymentsClient({ environment: env_txt });
		}
		return paymentsClient;
	}

	/**
	 * Initialize Google PaymentsClient after Google-hosted JavaScript has loaded
	 *
	 * Display a Google Pay payment button after confirmation of the viewer's
	 * ability to pay.
	 */
	function onGooglePayLoaded() {
		const paymentsClient = getGooglePaymentsClient();
		paymentsClient
			.isReadyToPay(getGoogleIsReadyToPayRequest())
			.then(function (response) {
				if (response.result) {
					// addGooglePayButton();
					// @todo prefetch payment data to improve performance after confirming site functionality
					// prefetchGooglePaymentData();
				}
			})
			.catch(function (err) {
				// show error in developer console for debugging
				console.error(err);
			});
	}

	/**
	 * Add a Google Pay purchase button alongside an existing checkout button
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#ButtonOptions|Button options}
	 * @see {@link https://developers.google.com/pay/api/web/guides/brand-guidelines|Google Pay brand guidelines}
	 */
	function addGooglePayButton() {
		const paymentsClient = getGooglePaymentsClient();
		const button =
			// paymentsClient.createButton({onClick: onGooglePaymentButtonClicked});
			paymentsClient.createButton({ buttonType: "plain" });
		// document.getElementById('google-pay-container').appendChild(button);
	}

	/**
	 * Provide Google Pay API with a payment amount, currency, and amount status
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#TransactionInfo|TransactionInfo}
	 * @returns {object} transaction info, suitable for use as transactionInfo property of PaymentDataRequest
	 */
	function getGoogleTransactionInfo(totalToPay) {
		return {
			countryCode: "SG",
			currencyCode: "SGD",
			totalPriceStatus: "FINAL",
			// set to cart total
			// totalPrice: '0.01'
			totalPrice: Number(totalToPay).toFixed(2),
		};
	}

	/**
	 * Prefetch payment data to improve performance
	 *
	 * @see {@link https://developers.google.com/pay/api/web/reference/client#prefetchPaymentData|prefetchPaymentData()}
	 */
	function prefetchGooglePaymentData() {
		const paymentDataRequest = getGooglePaymentDataRequest();
		// transactionInfo must be set but does not affect cache
		paymentDataRequest.transactionInfo = {
			totalPriceStatus: "NOT_CURRENTLY_KNOWN",
			currencyCode: "USD",
		};
		const paymentsClient = getGooglePaymentsClient();
		paymentsClient.prefetchPaymentData(paymentDataRequest);
	}

	/**
	 * Show Google Pay payment sheet when Google Pay payment button is clicked
	 */
	function onGooglePaymentButtonClicked(totalToPay, req_data) {
		const paymentDataRequest = getGooglePaymentDataRequest(totalToPay);
		paymentDataRequest.transactionInfo = getGoogleTransactionInfo(totalToPay);

		const paymentsClient = getGooglePaymentsClient();
		paymentsClient
			.loadPaymentData(paymentDataRequest)
			.then(function (paymentData) {
				// handle the response
				processPayment(paymentData, req_data);
			})
			.catch(function (err) {
				// show error in developer console for debugging
				console.error(err);
			});
	}

	/**
	 * Process payment data returned by the Google Pay API
	 *
	 * @param {object} paymentData response from Google Pay API after user approves payment
	 * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentData|PaymentData object reference}
	 */
	function processPayment(paymentData, req_data) {
		// show returned data in developer console for debugging
		console.log(paymentData);
		// @todo pass payment token to your gateway to process payment
		googlePayPaymentToken = paymentData.paymentMethodData.tokenizationData.token;
		if (googlePayPaymentToken) {
			callGooglePayEPayment(googlePayPaymentToken, req_data);
			console.log(googlePayPaymentToken);
		}
	}

	function callGooglePayEPayment(googlePayPaymentToken, req_data) {
		const omisePublicKeyUAT = process.env.REACT_APP_OMISE_PKEY_UAT;
		const omisePublicKeyPROD = process.env.REACT_APP_OMISE_PKEY_PROD;

		const currentUrl = window.location.href;

		const epaymentPayload = {
			omiseToken: "",
			omiseSource: "",
			eventregform_id: req_data.eventregform_id,
			payment_amount: req_data.eventregform_total_price,
			payment_method: "googlepay",
			signature: req_data.dataUrl,
		};

		setLoading(true);
		generalApi
			.epaymentForEvent(epaymentPayload)
			.then((d) => {
				if (d.status == 1) {
					if (currentUrl.includes("learn.sda.edu.sg")) {
						// production to load production pkey
						window.Omise.setPublicKey(omisePublicKeyPROD);
					} else {
						// uat / development to load uat pkey
						window.Omise.setPublicKey(omisePublicKeyUAT);
					}

					const tokenParameters = {
						method: "googlepay",
						data: googlePayPaymentToken,
					};

					window.Omise.createToken(
						"tokenization",
						tokenParameters,
						function (statusCode, response) {
							console.log(response);

							if (response.object == "error") {
								setLoading(false);
								MySwal.fire({
									title: "",
									html:
										"Error: " +
										response.code
											.toLowerCase()
											.replace("_", " ")
											.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()) +
										" - " +
										response.message
											.toLowerCase()
											.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase()),
									icon: "error",
								});
								return;
							}

							const chargePayload = {
								payment_id: d.data.payment_id,
								payment_mode: d.data.payment_mode,
								payment_amount: d.data.payment_amount,
								omiseToken: response.id,
							};

							generalApi
								.epaymentChargeCreditCardForEvent(chargePayload)
								.then((d) => {
									if (d.status == 2) {
										window.location.href = d.url;
										// const newSearchParam = [];
										// for(let entry of searchParams.entries()) {
										// 	newSearchParam.push(entry);
										// }
										// if (d.url.includes("?")) {
										// 	window.location.href = d.url + "&" + createSearchParams(getUrlParams(newSearchParam, checkoutAnalyticsData, courserun_id)).toString();
										// } else {
										// 	window.location.href = d.url + "?" +
										// }
									}
								})
								.catch((error) => {
									console.warn("error", error);
									// console.log(error);
									setLoading(false);
								});
						},
					);
				} else {
					setLoading(false);
				}
			})
			.catch((error) => {
				console.warn("error", error);
				// console.log(error);
				setLoading(false);
			});
	}

	async function handlePayment() {
		const dataUrl = canvasRef.current.toDataURL("image/png");
		if (checkboxTNC.current.checked === false) {
			MySwal.fire({
				title: "",
				html: "Please agree to the terms and conditions",
				icon: "error",
			});
			return;
		}

		if (canvasRef.current.isEmpty()) {
			// alert("Please sign the signature box");
			// 	const MySwal = withReactContent(Swal);
			MySwal.fire({
				title: "",
				html: "Please sign before continue",
				icon: "error",
				// icon: "warning",
				// didOpen: () => {
				// 	// `MySwal` is a subclass of `Swal` with all the same instance & static methods
				// 	MySwal.showLoading();
				// },
			});
			return;
		}

		if (paymentmethod == "creditcard") {
			const omisePublicKeyUAT = process.env.REACT_APP_OMISE_PKEY_UAT;
			const omisePublicKeyPROD = process.env.REACT_APP_OMISE_PKEY_PROD;
			const currentUrl = window.location.href;

			if (currentUrl.includes("learn.sda.edu.sg")) {
				// production to load production pkey
				window.OmiseCard.configure({
					publicKey: omisePublicKeyPROD,
				});
			} else {
				// uat / development to load uat pkey
				window.OmiseCard.configure({
					publicKey: omisePublicKeyUAT,
				});
			}

			const epaymentPayload = {
				omiseToken: "",
				omiseSource: "",
				eventregform_id: checkoutInfo.eventregform_id,
				payment_amount: checkoutInfo.eventregform_total_price,
				payment_method: "omise_credit_card",
				signature: dataUrl,
			};

			setLoading(true);
			const d = await generalApi.epaymentForEvent(epaymentPayload);
			if (d.status !== 1) {
				setLoading(false);
				return;
			}

			window.OmiseCard.open({
				amount: d.data.payment_amount,
				currency: "SGD",
				defaultPaymentMethod: "credit_card",
				onCreateTokenSuccess: (nonce) => {
					const chargePayload = {
						payment_id: d.data.payment_id,
						payment_mode: "omise_credit_card",
						payment_amount: d.data.payment_amount,
					};

					if (nonce.startsWith("tokn_")) {
						chargePayload.omiseToken = nonce;
					} else {
						chargePayload.omiseSource = nonce;
					}

					generalApi
						.epaymentChargeCreditCardForEvent(chargePayload)
						.then((d) => {
							if (d.status == 2) {
								window.location.href = d.url;
								// const newSearchParam = [];
								// for(let entry of searchParams.entries()) {
								// 	newSearchParam.push(entry);
								// }
								// if (d.url.includes("?")) {
								// 	window.location.href = d.url + "&" + createSearchParams(getUrlParams(newSearchParam, checkoutAnalyticsData, courserun_id)).toString();
								// } else {
								// 	window.location.href = d.url + "?" +
								// }
							}
						})
						.catch((error) => {
							console.warn("error", error);
							// console.log(error);
							setLoading(false);
						});
				},
			});
		} else if (paymentmethod == "paynow") {
			const data = {
				omiseToken: "",
				omiseSource: "",
				payment_method: "omise_paynow",
				signature: dataUrl,
				eventregform_id: checkoutInfo.eventregform_id,
			};
			const epaymentResult = await generalApi.epaymentForEvent(data);
			const newSearchParam = [];
			for (let entry of searchParams.entries()) {
				newSearchParam.push(entry);
			}
			// GTMCheckoutStep2GoPaynow(checkoutAnalyticsData, userData);
			navigate(
				{
					pathname: "/event/checkout/omise/paynow",
					// search: createSearchParams(getUrlParams(newSearchParam, checkoutAnalyticsData, courserun_id)).toString(),
				},
				{
					state: {
						payment_id: epaymentResult.data.payment_id,
						payment_paynow_qr: epaymentResult.data.payment_paynow_qr,
					},
				},
			);
		} else if (paymentmethod == "applepay") {
			const req_data = [];
			req_data.dataUrl = dataUrl;
			req_data.eventregform_id = checkoutInfo.eventregform_id;
			req_data.eventregform_total_price = checkoutInfo.eventregform_total_price;
			onApplePayButtonClicked(checkoutInfo.eventregform_total_price, req_data);
		} else if (paymentmethod == "googlepay") {
			const req_data = [];
			req_data.dataUrl = dataUrl;
			req_data.eventregform_id = checkoutInfo.eventregform_id;
			req_data.eventregform_total_price = checkoutInfo.eventregform_total_price;
			onGooglePaymentButtonClicked(checkoutInfo.eventregform_total_price, req_data);
		}

		// dispatch(
		// 	saveRegisterForm({
		// 		signature: dataUrl,
		// 	}),
		// );
		// navigate("/course/confirm");
	}

	return (
		<div>
			{/* Personal Detail */}
			<div className={styles.root}>
				<Row>
					<Col>
						<div className={"fs40 font-weight-bold text-color-dark"}>
							Welcome,{" "}
							<span className={styles.text_color_green}>{userData.user.learnermaster_name}</span>
						</div>
					</Col>
				</Row>
				<Row className="flex align-items-center mb-3">
					<div>
						<LearnerSvg className="ml-2" style={{ width: "60px" }} />
					</div>
					<div className={"font-weight-bold fs22 ml-2 text-color-dark"}>Learner Information</div>
				</Row>

				<Row
					style={{
						border: "1px solid #FFBD43",
						borderTop: "3px solid #FFBD43",
						padding: "30px 10px",
					}}>
					{personal_details.map((detail, index) => {
						return (
							<Col xs={12} md={6} lg={4} className="mt-2">
								<div className="font-weight-bold text-color-dark ">{detail.label}</div>
								<div className="pb-3 text-color-dark $fs15" style={{ wordWrap: "break-word" }}>
									{detail.value}
								</div>
							</Col>
						);
					})}
				</Row>

				{/* Event Detail */}
				<Row className="mt-4 flex align-items-center mb-3">
					<div>
						<EventSvg className="ml-2" style={{ width: "60px" }} />
					</div>
					<div className={"font-weight-bold fs22 ml-2 text-color-dark"}>Event Details</div>
				</Row>

				<Row
					style={{
						border: "1px solid #0085CA",
						borderTop: "3px solid #0085CA",
						padding: "30px 10px",
					}}>
					<Col xs={12}>{event.event_title}</Col>
					{event_details.map((item) => {
						return (
							<Col xs={12} md={6} lg={4} className="mt-4">
								<div className={"font-weight-bold fs16 text-color-dark"}>
									{<item.icon />}
									<span style={{ paddingLeft: 5 }}>{item.label}</span>
								</div>
								<div className={"text-color-dark fs15"}>{item.value}</div>
							</Col>
						);
					})}
				</Row>
			</div>

			{/* Registration Fee */}
			<div className={styles.root}>
				<Row className="flex align-items-center mb-3">
					<div className={"font-weight-bold fs30 ml-2 text-color-dark"}>Registration Fees</div>
				</Row>
				<Row className="flex align-items-center mb-3 fs22">
					<Col
						className="mt-2"
						xs={12}
						style={{
							border: "1px solid #0085CA",
							padding: "30px",
						}}>
						<div className="mb-3 fontwe">Registration Fees Breakdown</div>
						<Row>
							<Col>Total Nett Fees Payable</Col>
							<Col className="text-right">${checkoutInfo.eventregform_total_price}</Col>
						</Row>
						<Row>
							<Col>{checkoutInfo.eventregform_gst_percent} % GST </Col>
							<Col className="text-right">${checkoutInfo.eventregform_total_gst}</Col>
						</Row>

						<Divider style={{ margin: "40px 0" }} />
						<Row>
							<Col>
								<div style={{ fontWeight: "bold", fontSize: "26px", color: "#0085CA" }}>
									Total nett Fees Payable
								</div>
								<div className="fs16">
									{" "}
									(includes {checkoutInfo.eventregform_gst_percent}% GST){" "}
								</div>
							</Col>
							<Col
								className="text-right"
								style={{
									fontWeight: "bold",
									color: "#0085CA",
								}}>
								${checkoutInfo.eventregform_total_price_gst}
							</Col>
						</Row>
					</Col>
				</Row>
			</div>

			{/* Endorsement & Payment*/}
			<div className={styles.root}>
				<div className={"fs30 font-weight-bold text-color-dark"}>Endorsement & Payment</div>

				<div
					id="terms-and-conditions"
					onClick={toggleAccordion}
					className="cursor-pointer mt-4"
					style={{
						borderBottomWidth: "3px",
						borderBottomStyle: "solid",
						borderBottomColor: "rgb(207, 77, 134)",
					}}>
					<Row className="mb-3">
						<Col className="col col-auto">
							<TncSvg style={{ width: "60px" }} />
						</Col>
						<Col className="col d-flex align-items-center pl-0 font-weight-bold fs22 text-color-dark">
							Terms & Conditions
						</Col>
					</Row>
				</div>

				<div
					className="p-4"
					style={{ whiteSpace: "normal", wordWrap: "break-word" }}
					dangerouslySetInnerHTML={{ __html: event.event_term_condition }}></div>

				<Row className="pt-3  pb-3">
					<Col>
						<div className="pt-3">
							<div className="pb-2">
								<b className="text-color-dark">Your Signature</b>
								<a
									href="#"
									className="ml-2"
									onClick={(e) => {
										e.preventDefault();
										canvasRef.current.clear();
									}}>
									Clear
								</a>
							</div>
							<SignatureCanvas
								ref={canvasRef}
								clearOnResize={false}
								canvasProps={{
									height: 200,
									className: "sigCanvas border",
									style: { width: "100%", maxWidth: "500px" },
								}}
							/>
						</div>

						<div className="pt-2">
							<label htmlFor="tnc-checkbox">
								<input type="checkbox" id="tnc-checkbox" ref={checkboxTNC}></input>
								<span>
									&nbsp; I acknowledge that I have read and agree to the above
									<a
										href="#terms-and-conditions"
										className="ml-2 text-fca-blue text-underline cursor-pointer">
										terms and conditions.
									</a>
									<br />
									我确认我已阅读并同意上述
									<a
										href="#terms-and-conditions"
										className="ml-2 text-fca-blue text-underline cursor-pointer"
										onClick={(e) => {
											setAccordionOpen(true);
										}}>
										条款和条件
									</a>
								</span>
							</label>
						</div>
					</Col>
				</Row>

				<Row className="p-3">
					<Col className="border pb-3">
						{/* {Number(nettFeePayableAmount - sfcClaimedAmount) > 0 ? ( */}
						<Row>
							<Col>
								<div className="mt-4 select-payment-method">
									<span className="fs18 text-color-dark">Select One Payment Method</span>
								</div>
								<div className="mt-3 ml-4">
									<div className="payment-method-div flex flex-row justify-content-center">
										<div
											className={`payment-method-div-paynow text-center ${
												paymentmethod === "paynow" ? "active" : ""
											}`}
											onClick={selectPaymentmethod}
											data-method="paynow">
											<img className="payment-logo-paynow" src={paynowLogo} />
											<span>Paynow</span>
											<span>
												Pay the balance amount using<br></br>Paynow
											</span>
										</div>
										<div
											className={`payment-method-div-paynow text-center ${
												paymentmethod === "creditcard" ? "active" : ""
											}`}
											onClick={selectPaymentmethod}
											data-method="creditcard">
											<img className="payment-logo-cc" src={ccLogo} />
											<span>Credit Card</span>
											<span>
												Pay the balance amount using<br></br>credit card
											</span>
										</div>
									</div>
									<div className="payment-method-div flex flex-row justify-content-center">
										<div
											className={`payment-method-div-paynow text-center ${
												paymentmethod === "applepay" ? "active" : ""
											}`}
											onClick={selectPaymentmethod}
											data-method="applepay">
											{/* <apple-pay-button buttonstyle="black" type="plain" locale="en-US"></apple-pay-button> */}
											<img src={applePay} style={{ height: "30px" }} />
											<span>Apple Pay</span>
											<span>
												Pay the balance amount using<br></br>Apple Pay
											</span>
										</div>
										<div className="payment-method-div flex flex-row justify-content-center">
											<div
												className={`payment-method-div-paynow text-center ${
													paymentmethod === "googlepay" ? "active" : ""
												}`}
												onClick={selectPaymentmethod}
												data-method="googlepay">
												<img className="payment-logo-cc" src={googlePay} />
												<span>Google Pay</span>
												<span>
													Pay the balance amount using<br></br>Google Pay
												</span>
											</div>
										</div>
									</div>
								</div>
							</Col>
						</Row>

						<Row className="pt-2 align-items-end">
							<Col className="">
								<div
									style={{
										display: "flex",
										alignItems: "flex-end",
										justifyContent: "flex-end",
										width: "100%",
									}}>
									{loading && (
										<div className="d-flex justify-content-center">
											<div className="spinner-border" role="status">
												<span className="sr-only">Loading...</span>
											</div>
										</div>
									)}
									<Button
										type="button"
										className="btn-gradient"
										disabled={disabled}
										onClick={handlePayment}>
										Continue
									</Button>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		</div>
	);
};
